<kendo-dialog-titlebar>
    {{'shared.header.addNewCarBrand' | translate}}
</kendo-dialog-titlebar>

<div fxLayout="column" fxLayoutGap="15px">
    <form [formGroup]="dataForm">
        <text-input-ctrl [caption]="'shared.brandName'" [formControlName]="'value'" [settings]="{fxFill:true,uppercase:true}"></text-input-ctrl>
    </form>

    <div fxLayoutAlign="center center" fxLayoutGap="15px">
        <button type="button" kendoButton (click)="cancel()">{{'global.cancel' | translate}}</button>
        <button type="button" kendoButton (click)="confirm()" [primary]="true">
            <span>{{'global.add' | translate}}</span>
        </button>
    </div>
</div>